@if (organizationInformations) {
<div class="organization-container">
    <div class="page-top-banner">
        <div class="title">
            Partenaire
            {{ organizationInformations.display ? '"' + organizationInformations.display + '"' : '' }}
        </div>
    </div>

    <div class="content">
        <form [formGroup]="organizationForm" (ngSubmit)="onSubmit()">
            <mat-tab-group>
                <mat-tab label="Général">
                    <div>
                        @if (organizationInformations !== undefined && organizationList !== undefined) {
                        <div formGroupName="generalGroup">
                            <mat-card class="box">
                                <mat-card-content>

                                    @if (!isCreation) {
                                    <mat-checkbox [checked]="organizationEnabled"
                                        (change)="organizationEnabled = $event.checked">
                                        Organisation active
                                    </mat-checkbox>
                                    }
                                    @if (isCreation) {
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Organisation parente</mat-label>
                                        <input matInput formControlName="displayParentOrganization" readonly />
                                    </mat-form-field>
                                    }
                                    @if (!isCreation && organizationInformations.displayParentOrganization) {
                                    <div>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Organisation parente</mat-label>
                                            <input matInput formControlName="displayParentOrganization" readonly />
                                        </mat-form-field>
                                    </div>
                                    }
                                    <div>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Nom du partenaire</mat-label>
                                            <input matInput formControlName="display" required />
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>SIRET / SIREN</mat-label>
                                            <input matInput formControlName="siret" required />
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Code SI du partenaire</mat-label>
                                            <input matInput formControlName="internalRef" required />
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Contact email</mat-label>
                                            <input matInput formControlName="email" required />
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Contact téléphone</mat-label>
                                            <input matInput formControlName="phone" required />
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Adresse</mat-label>
                                            <input matInput formControlName="address" required />
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Code postal</mat-label>
                                            <input matInput formControlName="zipCode" required />
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Ville</mat-label>
                                            <input matInput formControlName="city" required />
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Pays</mat-label>
                                            <input matInput formControlName="country" required />
                                        </mat-form-field>
                                    </div>

                                </mat-card-content>
                            </mat-card>
                        </div>
                        }
                    </div>
                </mat-tab>

                @if (!isCreation) {
                <mat-tab label="Propriétés">
                    @if (organizationInformations) {
                    <div>
                        <app-gum-properties [properties]="organizationProperties" [affinity]="affinity"
                            (isValid)="propertiesValid = $event"
                            (changed)="onPropertiesChanged($event)"></app-gum-properties>
                    </div>
                    }
                </mat-tab>
                }
            </mat-tab-group>
            <div class="buttons-band">
                <button mat-stroked-button class="accent-button" type="button"
                    (click)="cancelButtonClick()">Annuler</button>
                <button mat-raised-button class="accent-button"
                    [disabled]="!organizationForm.valid || (!isCreation && !propertiesValid)" type="submit">
                    Valider
                </button>
            </div>
        </form>
    </div>
</div>
}